const GET_LEADERBOARDS = `
  query GetLeaderboards($request: AWSJSON!) {
    getLeaderboards(request: $request)
  }
`;

export default GET_LEADERBOARDS;
